export const truncateText = (text: string, maxLength: number = 70) => {
  if (text.length <= maxLength) return text;

  const halfLength = maxLength / 2;
  const firstHalf = text.slice(0, halfLength);
  const secondHalf = text.slice(-halfLength);

  return `${firstHalf}...${secondHalf}`;
};
